export default function LivePostsIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Live Posts Icon</title>
      <path
        d="M15.3839 3.81934C14.9184 3.81934 14.5376 4.20015 14.5376 4.66559V19.334C14.5376 19.7995 14.9184 20.1803 15.3839 20.1803C15.8493 20.1803 16.2301 19.7995 16.2301 19.334V4.66559C16.2301 4.20015 15.8493 3.81934 15.3839 3.81934Z"
        fill="currentColor"
      />
      <path
        d="M19.8978 6.35742C19.4323 6.35742 19.0515 6.73824 19.0515 7.20368V16.7946C19.0515 17.26 19.4323 17.6408 19.8978 17.6408C20.3632 17.6408 20.744 17.26 20.744 16.7946V7.20368C20.744 6.73824 20.3632 6.35742 19.8978 6.35742Z"
        fill="currentColor"
      />
      <path
        d="M11.7172 5.69774C11.7172 4.35219 10.6227 3.25488 9.27434 3.25488C8.94148 3.25488 8.61708 3.32258 8.31243 3.45234L4.73559 4.98407C3.83573 5.37052 3.25464 6.25063 3.25464 7.22946V16.7668C3.25464 17.7456 3.83573 18.6257 4.73559 19.0122L8.31243 20.5467C8.61708 20.6765 8.94148 20.7442 9.27434 20.7442C10.6199 20.7442 11.7172 19.6497 11.7172 18.3013V5.69774ZM10.0247 18.3013C10.0247 18.716 9.689 19.0517 9.27434 19.0517C9.17279 19.0517 9.07406 19.0319 8.97815 18.9924L5.40131 17.4579C5.12486 17.3394 4.94715 17.0686 4.94715 16.7696V7.23229C4.94715 6.93327 5.12486 6.66247 5.40131 6.544L8.97815 5.00945C9.07124 4.96996 9.17279 4.94739 9.27434 4.94739C9.689 4.94739 10.0247 5.28308 10.0247 5.69774V18.3013Z"
        fill="currentColor"
      />
    </svg>
  );
}
